import { FormGroup } from '@angular/forms';

import { AmountMaxValidatorKey } from '@spa/validators';

import { BaseControl, Helper } from 'appShared/classes';

/**
 * Reads a redemption cap off the form. Both caps are optional — an empty one means "unlimited" —
 * so anything blank comes back as null rather than 0.
 */
export const CouponCapValue = (value: any): number => {
    if (value === null || value === undefined || value === '') {
        return null;
    }

    const parsed = Helper.getAmountValue(value);

    return isNaN(parsed) ? null : parsed;
};

/**
 * The backend rejects a per-user cap above the total cap. The rule spans two controls, so it cannot
 * live on either one's validators.
 */
export const CouponRedemptionCapsValid = (
    formGroup: FormGroup,
    globalCapControl: BaseControl,
    perUserCapControl: BaseControl,
    messagesFunction: (controlLabel?: string, controlLength?: number) => { [key: string]: string }
): boolean => {
    perUserCapControl.resetErrors();

    const values = formGroup.getRawValue();
    const globalCap = CouponCapValue(values[globalCapControl.name]);
    const perUserCap = CouponCapValue(values[perUserCapControl.name]);

    if (globalCap === null || perUserCap === null || perUserCap <= globalCap) {
        return true;
    }

    perUserCapControl.setError(messagesFunction(perUserCapControl.placeholder, globalCap)[AmountMaxValidatorKey]);

    return false;
};
